import React from 'react';
import _ from 'lodash';
import { StoryblokComponent, storyblokEditable } from 'gatsby-source-storyblok';
// eslint-disable-next-line max-len
import type { ProductComparisonProductSpecificationList as IProductComparisonProductSpecificationList } from '../../../../.storyblok/types/255103/storyblok-components';
import Col from '../../FlexboxGrid/Col';
import Row from '../../FlexboxGrid/Row';

interface ProductComparisonProductSpecificationListProps {
  blok: IProductComparisonProductSpecificationList;
}

const ProductComparisonProductSpecificationList = ({ blok }: ProductComparisonProductSpecificationListProps) => {
  const specifications = _.get(blok, 'productSpecificationContent', []);

  return (
    <div
      className="w-full flex flex-col flex-nowrap border-b border-solid border-gray-100"
      {...storyblokEditable(blok)}
    >
      {specifications.map((specification) => {
        return (
          <div className="w-full border-t border-solid border-gray-100 py-10 gap-y-[25px]" key={specification._uid}>
            <h3 className="typography-eyebrow-s sm:typography-eyebrow-m !text-gray-200">{specification.heading}</h3>

            {/* @ts-expect-error Row is not yet refactored */}
            <Row className="flex flex-row flex-nowrap pt-[25px]">
              {!_.isEmpty(specification.contentColumnLeft) && (
                // @ts-expect-error Col is not yet refactored
                <Col xs={4} md={5} lg={6}>
                  <StoryblokComponent blok={specification.contentColumnLeft.find((el) => el) ?? {}} />
                </Col>
              )}

              {!_.isEmpty(specification.contentColumnRight) && (
                // @ts-expect-error Col is not yet refactored
                <Col xs={4} md={5} lg={6}>
                  <StoryblokComponent blok={specification.contentColumnRight.find((el) => el) ?? {}} />
                </Col>
              )}
            </Row>
          </div>
        );
      })}
    </div>
  );
};

export default ProductComparisonProductSpecificationList;
